import React from "react";

import { CSSGrid } from "@components/Layout/CssGrid";

import {
  InteriorWindows,
  Fridge,
  WhipOven,
  DresserDrawers,
  DoorHandleLock,
  RhombusRectangular,
  Blinds,
  Balcony as BalconyIcon,
} from "@ui/Assets/MyIcons";

import { getItem } from "./Tabs.helpers";

const WindowCleaning = getItem(
  "extras_service_interior_windows",
  InteriorWindows,
  "WindowCleaning",
);

const DoorHandles = getItem(
  "extras_service_door_handles",
  DoorHandleLock,
  "DoorHandles",
);

const InsideFridge = getItem(
  "extras_service_inside_fridge",
  Fridge,
  "InsideFridge",
);

const InsideOven = getItem(
  "extras_service_inside_oven",
  WhipOven,
  "InsideOven",
);

const InsideCabinets = getItem(
  "extras_service_inside_cabinets",
  DresserDrawers,
  "InsideCabinets",
);

const Baseboards = getItem(
  "extras_service_baseboards",
  RhombusRectangular,
  "Baseboards",
);

const WindowBlinds = getItem(
  "extras_service_window_blinds",
  Blinds,
  "WindowBlinds",
);

const Balcony = getItem("extras_service_balcony", BalconyIcon, "Balcony");

export const endOfTenancyAreas = CSSGrid.areas({
  WindowCleaning,
  DoorHandles,
  InsideFridge,
  InsideOven,
  InsideCabinets,
  Baseboards,
  WindowBlinds,
  Balcony,
});

endOfTenancyAreas.all(
  (
    {
      WindowCleaning,
      DoorHandles,
      InsideFridge,
      InsideOven,
      InsideCabinets,
      Baseboards,
      WindowBlinds,
      Balcony,
    },
    { compose, repeat },
  ) => [
    compose(repeat(WindowCleaning, 6), repeat(DoorHandles, 6)),
    compose(repeat(InsideFridge, 6), repeat(InsideOven, 6)),
    compose(repeat(InsideCabinets, 6), repeat(Baseboards, 6)),
    compose(repeat(WindowBlinds, 6), repeat(Balcony, 6)),
  ],
);

endOfTenancyAreas.smallTablet(
  (
    {
      WindowCleaning,
      DoorHandles,
      InsideFridge,
      InsideOven,
      InsideCabinets,
      Baseboards,
      WindowBlinds,
      Balcony,
    },
    { compose, repeat },
  ) => [
    compose(
      repeat(WindowCleaning, 4),
      repeat(DoorHandles, 4),
      repeat(InsideFridge, 4),
    ),
    compose(
      repeat(InsideOven, 4),
      repeat(InsideCabinets, 4),
      repeat(Baseboards, 4),
    ),
    compose(repeat(WindowBlinds, 4), repeat(Balcony, 4)),
  ],
);
